import React from "react";
import { Link } from "gatsby";
import { CheckCircle } from "react-feather";
import cityNeighborhoods from "../data/city-neighborhoods";
import cityPageContent from "../data/city-page-content";

const CityNeighborhoods = ({ city, cities, serviceSlug }) => {
  const cityName = String(city).trim();
  const key = cityName.toLowerCase();
  const neighborhoods = cityNeighborhoods[key];

  if (!neighborhoods || neighborhoods.length === 0) {
    return null;
  }

  // Several of these entries are nearby towns that have their own service-area
  // page. Resolve them against the Contentful city list rather than hardcoding
  // hrefs, so a town added to Contentful later links itself and one that is
  // removed stops linking instead of 404ing. Genuine neighbourhoods (Godfrey-Lee,
  // Wildwood Park, ...) simply never match and stay plain text.
  const pageFor = new Map(
    (cities || [])
      .map((edge) => edge && edge.node)
      .filter((node) => node && node.location && node.slug)
      .map((node) => [String(node.location).trim().toLowerCase(), `/${serviceSlug}-${node.slug}/`])
  );

  // Entries are either a plain name or { name, zips }.
  const entries = neighborhoods.map((entry) => {
    const item = typeof entry === "string" ? { name: entry } : entry;
    const to = serviceSlug ? pageFor.get(item.name.trim().toLowerCase()) : undefined;
    // Never link a city back to the page you are already on.
    return { ...item, to: to && item.name.trim().toLowerCase() !== key ? to : undefined };
  });
  const { neighborhoodsHeading } = cityPageContent.forCity(city);

  return (
    <section className="py-12 md:py-20 bg-neutral-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-center text-2xl md:text-3xl font-display font-extrabold text-neutral-900 mb-3 leading-tight">
          {neighborhoodsHeading || `Service Areas We Service In ${cityName}, MI`}
        </h2>
        <p className="text-center text-neutral-600 mb-10 md:mb-12 max-w-2xl mx-auto">
          Trusted roofing throughout every neighborhood in and around {city}.
        </p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-5 list-none p-0 m-0">
          {entries.map(({ name, zips, to }) => (
            <li key={name} className="flex items-start gap-3">
              <CheckCircle
                size={18}
                strokeWidth={2.5}
                className="text-brand-500 mt-1 flex-shrink-0"
              />
              <div>
                <div className="font-semibold text-neutral-900 leading-snug">
                  {to ? (
                    <Link
                      to={to}
                      className="text-neutral-900 hover:text-brand-600 no-underline"
                      title={`Roofing in ${name}, MI`}
                    >
                      {name}
                    </Link>
                  ) : (
                    name
                  )}
                </div>
                <div className="text-xs sm:text-sm text-neutral-500">
                  {zips || "Roofing Contractor"}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CityNeighborhoods;
